import React from 'react'
import styled from 'styled-components'

import LabelledField from 'components/LabelledField'

import { color } from 'styles/colors'

type props = {
  label?: string
  value: string | undefined
  options: Array<string>
  onSelectChange: (event) => void
  onInputChange: (event) => void
  onBlur: (event) => void
  className?: string
  autoFocus?: boolean
  errorMessage?: string
}

const ComboBox = ({ label = '', value, options, onSelectChange, onInputChange, onBlur, className, autoFocus = false, errorMessage, ...inputProps }: props) => (
  <S.TextField {...{ label, className, errorMessage }} id={label}>
    <S.InputWrapper>
      <S.Select onChange={onSelectChange}>
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </S.Select>

      <S.Input
        autoFocus={autoFocus}
        id={label}
        value={value}
        onBlur={onBlur}
        onChange={onInputChange}
        {...inputProps}
      />
    </S.InputWrapper>
  </S.TextField>
)

const height = '39px'
const S = {
  TextField: styled(LabelledField)`
  `,
  InputWrapper: styled.div`
    position: relative;
    height: ${height};
  `,
  Select: styled.select`
    height: ${height};
    width: 100%;
    padding-right: 25px;
    box-shadow: none;
    border: none;
  `,
  Input: styled.input`
    height: ${height};
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 26px);
    padding-left: 6px;
    color: ${color('primaryText')};
    border: 1px solid ${color('border')};

    &:focus {
      outline: none;
    }
  `
}

export default ComboBox
